import React from 'react';
import { WorkflowTriggers } from '@prenuvo/workflow-triggers';

import './WorkflowTriggers.css';
import { extractUrlProperties } from './url.util';

function WorkflowTriggersWidget(): JSX.Element {
  const { api, studyId } = extractUrlProperties();

  return (
    <div className="workflow-triggers-widget">
      <WorkflowTriggers studyId={studyId} api={api} />
    </div>
  );
}

export default WorkflowTriggersWidget;
